import { motion } from "framer-motion";
import { BsExclamationTriangleFill } from "react-icons/bs";

const OrderLimitAlert = () => {
  return (
    <motion.div
      className="alert alert-warning d-flex align-items-center rounded-3 shadow-sm"
      role="alert"
      initial={{ opacity: 0, y: -15 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <BsExclamationTriangleFill
        className="flex-shrink-0 me-2"
        size={24}
      />
      <div>
        <strong>Atención:</strong> Por motivos de seguridad, el límite de compra permitido para realizar el pago es de{" "}
        <strong>$10.000.000 COP</strong>. Si deseas adquirir un valor mayor, por favor divide tu compra en varias órdenes.  
        ¡Gracias por tu comprensión y confianza!
      </div>
    </motion.div>
  );
};

export default OrderLimitAlert;
